import { motion } from "framer-motion";

const ElevatorShaft = () => {
  return (
    <div className="relative w-24 h-64 mx-auto">
      {/* Shaft Frame */}
      <div className="absolute inset-0 border-4 border-primary/30 rounded-lg bg-gradient-to-b from-muted/50 to-muted overflow-hidden">
        {/* Shaft Rails */}
        <div className="absolute left-2 top-0 bottom-0 w-1 bg-primary/20" />
        <div className="absolute right-2 top-0 bottom-0 w-1 bg-primary/20" />
        
        {/* Floor Indicators */}
        {[0, 1, 2, 3, 4].map((floor) => (
          <div
            key={floor}
            className="absolute left-0 right-0 h-px bg-primary/10"
            style={{ top: `${floor * 25}%` }}
          />
        ))}
        
        {/* Animated Elevator Cabin */}
        <motion.div
          className="absolute left-3 right-3 h-12 bg-gradient-to-b from-primary to-primary/80 rounded-md shadow-lg"
          animate={{
            y: [8, 180, 8],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          {/* Cabin Door Lines */}
          <div className="absolute inset-1 flex gap-0.5">
            <motion.div 
              className="flex-1 bg-primary-foreground/20 rounded-sm"
              animate={{
                scaleX: [1, 0.3, 1],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
                times: [0, 0.5, 1],
              }}
              style={{ transformOrigin: "left" }}
            />
            <motion.div 
              className="flex-1 bg-primary-foreground/20 rounded-sm"
              animate={{
                scaleX: [1, 0.3, 1],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
                times: [0, 0.5, 1],
              }}
              style={{ transformOrigin: "right" }}
            />
          </div>
          
          {/* Cabin Light */}
          <motion.div
            className="absolute -top-1 left-1/2 -translate-x-1/2 w-3 h-1 rounded-full bg-accent"
            animate={{
              opacity: [1, 0.5, 1],
            }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        </motion.div>
        
        {/* Cable */}
        <motion.div
          className="absolute left-1/2 -translate-x-1/2 w-0.5 bg-muted-foreground/30 origin-top"
          animate={{
            height: [20, 192, 20],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      </div>
      
      {/* Floor Numbers */}
      <div className="absolute -right-8 top-0 bottom-0 flex flex-col justify-between py-2 text-xs text-muted-foreground font-medium">
        <span>5</span>
        <span>4</span>
        <span>3</span>
        <span>2</span>
        <span>1</span>
      </div>
    </div>
  );
};

export default ElevatorShaft;
